import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "./features/auth/Login";
import Welcome from "./features/welcome/Welcome";
import { getStoredUser, removeAuth, saveAuth } from "./features/auth/authStorage";
import AdminLayout from "./features/layout/admin/AdminLayout";
import PatientLayout from "./features/layout/paciente/PatientLayout";
import MedicoLayout from "./features/layout/medico/MedicoLayout";
import "./App.css";

const BASE_PATH_BY_ROL = {
    admin: "/admin",
    recepcionista: "/admin",
    medico: "/medico",
    paciente: "/paciente",
};

const DEFAULT_PAGE_BY_ROL = {
    admin: "servicios",
    recepcionista: "servicios",
    medico: "turnos",
    paciente: "turnos",
};

function App() {
    const [user, setUser] = useState(getStoredUser);

    const handleLogin = (data) => {
        const { user: loggedUser, token } = data;
        saveAuth(loggedUser, token);
        setUser(loggedUser);
    };

    const handleLogout = () => {
        removeAuth();
        setUser(null);
    };

    if (!user) {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Welcome />} />
                    <Route path="/login" element={<Login onLogin={handleLogin} initialMode="login" />} />
                    <Route path="/registro" element={<Login onLogin={handleLogin} initialMode="registro" />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        );
    }

    const basePath = BASE_PATH_BY_ROL[user.rol] || "/admin";
    const defaultPage = DEFAULT_PAGE_BY_ROL[user.rol] || "servicios";
    const fallbackRedirect = `${basePath}/${defaultPage}`;

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/admin/:page"
                    element={
                        user.rol === "admin" || user.rol === "recepcionista" ? (
                            <AdminLayout user={user} onLogout={handleLogout} />
                        ) : (
                            <Navigate to={fallbackRedirect} replace />
                        )
                    }
                />
                <Route
                    path="/medico/:page"
                    element={
                        user.rol === "medico" ? (
                            <MedicoLayout user={user} onLogout={handleLogout} />
                        ) : (
                            <Navigate to={fallbackRedirect} replace />
                        )
                    }
                />
                <Route
                    path="/paciente/:page"
                    element={
                        user.rol === "paciente" ? (
                            <PatientLayout user={user} onLogout={handleLogout} />
                        ) : (
                            <Navigate to={fallbackRedirect} replace />
                        )
                    }
                />
                <Route path="*" element={<Navigate to={fallbackRedirect} replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;